import { useEffect } from 'react';

import {
	useFirePostOfficeTrigger,
	useTrigger,
} from '@atlassian/post-office-context/post-office-trigger';

export const usePostOfficeCoordination = (
	messageId: string,
): readonly [boolean | undefined, (force?: boolean) => void] => {
	const { isActive: poIsActive } = useTrigger(`${messageId}-started`);
	const { fireTrigger: poRequestMessageStart } = useFirePostOfficeTrigger({
		triggerId: `${messageId}-start`,
	});
	const { fireTrigger: poFireDismissClick } = useFirePostOfficeTrigger({
		triggerId: `${messageId}-dismiss`,
	});

	useEffect(() => {
		poRequestMessageStart({ isActive: true });
	}, [messageId, poRequestMessageStart]);

	const started = poIsActive;

	const stop = (force?: boolean) => {
		poFireDismissClick({ isActive: true });
	};
	return [started, stop] as const;
};
